// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"9ffe8a46","82":"1152fe9e","171":"a1339909","246":"476c9dd7","313":"2b93824e","379":"330f201a","391":"f62210e7","453":"627a36f8","607":"4b749dcb","625":"89b0762d","650":"d01ae340","706":"e12efa15","752":"cc60a069","875":"0988f7ab","991":"1c6cf374"}[chunkId] + ".chunk.js";
};